export const NUMBER_OF_CONFETTI = 200;
export const DURATION = 8000;
export const ROTATION_RANGE = 10;
export const ROTATION_RATE = 100;
export const SPEED_RANGE = 10;
export const SPRITE_WIDTH = 9;
export const SPRITE_HEIGHT = 16;
export const COLORS = [
  '#EF5350',
  '#EC407A',
  '#AB47BC',
  '#7E57C2',
  '#5C6BC0',
  '#42A5F5',
  '#29B6F6',
  '#26C6DA',
  '#26A69A',
  '#66BB6A',
  '#9CCC65',
  '#D4E157',
  '#FFEE58',
  '#FFCA28',
  '#FFA726',
  '#FF7043',
  '#8D6E63',
  '#BDBDBD',
  '#78909C',
];

export default {
  NUMBER_OF_CONFETTI,
  DURATION,
  ROTATION_RANGE,
  ROTATION_RATE,
  SPEED_RANGE,
  SPRITE_WIDTH,
  SPRITE_HEIGHT,
  COLORS,
};
